import { Path } from '@/main/router/routerPath';

import { CRUMB_LABEL_KEY, NAME } from './constants';
import List from './List.vue';

export const router = new Path(NAME, { List, SelectList: List }, CRUMB_LABEL_KEY);
